export default __webpack_public_path__ + "static/bochnia-header-14d41fd2bf97f99f0c77966c7793b1d9.jpg";